import { connect } from 'react-redux';
import { bindActionCreators, Dispatch, Action } from 'redux';

import { createIncentiveAgreement, getStartupById, updateIncentiveAgreement } from 'redux/actions/startups';
import { setDrawerBody } from 'redux/actions/workspace';
import { StateType } from 'types';
import { selectUserType } from 'redux/selectors/auth';

const mapStateToProps = (state: StateType) => ({
  userType: selectUserType(state),
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  actions: bindActionCreators({
    setDrawerBody,
    createIncentiveAgreement,
    updateIncentiveAgreement,
    getStartupById,
  }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps);
